(() => {
  'use strict';

  const selectWithin = (root, selector) => root.querySelector(selector);

  const initJurisdictionFilter = (root) => {
    const container = selectWithin(root, '[data-guide-jurisdiction-filter]');
    if (!container || container.dataset.initialized === 'true') return;

    const form = selectWithin(container, '[data-guide-filter-form]');
    const records = [...container.querySelectorAll('[data-guide-jurisdiction]')];
    const empty = selectWithin(container, '[data-guide-filter-empty]');
    if (!form || !records.length || !empty) return;

    const apply = () => {
      const noSsnResidency = form.elements.namedItem('no_ssn_residency')?.checked === true;
      const noDegree = form.elements.namedItem('no_degree')?.checked === true;
      let visible = 0;

      records.forEach((record) => {
        const matches = (!noSsnResidency || record.dataset.noSsnResidency === 'true') &&
          (!noDegree || record.dataset.noDegree === 'true');
        record.hidden = !matches;
        if (matches) visible += 1;
      });

      empty.hidden = visible !== 0;
    };

    form.addEventListener('change', apply);
    form.addEventListener('submit', (event) => event.preventDefault());
    form.addEventListener('reset', () => window.requestAnimationFrame(apply));
    container.dataset.initialized = 'true';
    apply();
  };

  const initCreditConverter = (root) => {
    const form = selectWithin(root, '[data-credit-converter]');
    if (!form || form.dataset.initialized === 'true') return;

    const amount = form.elements.namedItem('amount');
    const direction = form.elements.namedItem('direction');
    const output = selectWithin(form, '[data-credit-converter-output]');
    if (!amount || !direction || !output) return;

    const update = () => {
      const value = Number.parseFloat(amount.value);
      if (!Number.isFinite(value) || value < 0) {
        output.textContent = 'Enter your hours to begin.';
        return;
      }

      const quarterToSemester = direction.value === 'quarter-to-semester';
      const result = quarterToSemester ? value * (2 / 3) : value * 1.5;
      const unit = quarterToSemester ? 'semester hours' : 'quarter hours';
      output.textContent = `${result.toFixed(2)} estimated ${unit}`;
    };

    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', (event) => event.preventDefault());
    form.dataset.initialized = 'true';
  };

  const initScoreWindowLookup = (root) => {
    const container = selectWithin(root, '[data-score-window-lookup]');
    if (!container || container.dataset.initialized === 'true') return;

    const select = selectWithin(container, '[data-score-window-select]');
    const result = selectWithin(container, '[data-score-window-result]');
    if (!select || !result) return;

    const update = () => {
      const option = select.selectedOptions[0];
      if (!option?.value) {
        result.innerHTML = '<p>Choose a jurisdiction to load its researched summary.</p>';
        return;
      }

      const heading = document.createElement('h3');
      heading.textContent = `${option.dataset.name}: ${option.dataset.window}`;
      const note = document.createElement('p');
      note.textContent = option.dataset.note;
      const warning = document.createElement('p');
      warning.textContent = 'Use the expiration shown in your official candidate record as the operational deadline.';
      const link = document.createElement('a');
      link.href = option.dataset.url;
      link.textContent = 'Review the jurisdiction page and official sources';

      result.replaceChildren(heading, note, warning, link);
    };

    select.addEventListener('change', update);
    container.dataset.initialized = 'true';
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-cpa-candidate-guide]').forEach((root) => {
      initJurisdictionFilter(root);
      initCreditConverter(root);
      initScoreWindowLookup(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
